<template>
  <Wrapper class="container-fluid">
    <div class="hero-section">
      <div class="video">
        <MuxVideo
          mux-id="O76Qx02SXeDvzzqCM5A3rbPm6I9uTby5ChGLBzND7Pkc"
          :blur="false"
          :fallbackImage="`${imageUrl}/images/particles.png`"
        />
        <div class="overlay">
          <div class="gradient"></div>
        </div>
      </div>
      <div class="title">
        <h1>Together, we</h1>
        <h2>make it happen</h2>
      </div>
    </div>
    <div
      class="container-fluid_wrapper"
      data-aos="fade-up"
      data-aos-duration="1000"
      data-aos-once="true"
    >
      <div class="container-fluid_wrapper_child">
        <div class="content creator" style="">
          <p>
            Our advanced machine learning models turn real-world environments
            into immersive digital replicas using smartphone data, making it
            easy and engaging to create and explore places digitally.
          </p>
          <p>
            Travvir is expanding globally, revolutionizing how places are
            digitally captured and experienced.
          </p>
        </div>
      </div>
    </div>
  </Wrapper>
  <div class="second-image">
    <div class="image">
      <NuxtImg :src="baseUrl + `/about-background.jpg`" alt="" />
      <div class="overlay-top"></div>
      <div class="overlay-bottom"></div>
    </div>
    <div class="image-text">
      <h1 class="main-title">Building meaningful connections</h1>
    </div>
  </div>
</template>
<script setup>
import { useRuntimeConfig } from "nuxt/app";
import { onMounted } from "vue";
const { $Aos } = useNuxtApp();
const config = useRuntimeConfig();
const baseUrl = config.public.NUXT_CDN_URL + "/static/website";
const imageUrl = config.public.NUXT_CDN_URL + "/static";
onMounted(() => {
  $Aos.init();
});
</script>

<style lang="scss" scoped>
.container-fluid {
  min-height: calc(var(--vh, 1vh) * 100);
  max-width: 1300px;
  &_wrapper {
    display: flex;
    @include respond-below(sm) {
      flex-direction: column-reverse;
    }
    width: 100%;
    &_child {
      @include respond-below(sm) {
        width: 100%;
      }
    }
    &_Child1 {
      @include respond-below(sm) {
        width: 100%;
      }
    }
  }
}
.hero-section {
  font-family: "Book21", "Sharp Grotesk", sans-serif;
  min-height: calc(var(--vh, 1vh) * 85);
  height: 100%;
  display: flex;
  padding: 4rem 0;
  background: rgba(10, 10, 10, 0.2);
  text-align: center;
  justify-content: center;
  @include respond-below(sm) {
    padding: 2rem 0;
    height: calc(var(--vh, 1vh) * 70);
  }
  .video {
    position: absolute;
    top: 0%;
    left: 50%;
    transform: translate(-50%, 0);
    width: 100%;
    height: 100%;
    object-fit: cover;
    filter: blur(1.5rem) contrast(1.2) brightness(0.85);
    @include respond-below(sm) {
      filter: blur(1.2rem);
      top: 38%;
      transform: translate(-50%, -50%);
      height: calc(var(--vh, 1vh) * 125);
    }
    img {
      width: 100%;
      height: 70%;
      object-fit: cover;
      position: absolute;
      left: 0%;
      z-index: 1;
      @include respond-below(sm) {
        height: 100%;
        object-fit: contain;
      }
    }
    &:deep(img) {
      object-fit: cover;
      width: 100%;
      @include respond-below(sm) {
        height: 100%;
        object-fit: cover;
      }
    }
    &:deep(video) {
      width: 100%;
      height: 100%;
      object-fit: cover;
      @include respond-below(sm) {
        height: 100%;
        object-fit: cover;
      }
    }
  }
  .title {
    max-width: 1200px;
    position: absolute;
    z-index: 2;
    bottom: 8%;
    margin-top: 3rem;
    width: 100%;
    display: flex;
    flex-direction: column;
    letter-spacing: clamp(-2px, 1.5vw, -8.68px);
    line-height: clamp(40px, 20vw, 140.6px);
    @include respond-below(sm) {
      bottom: 5%;
    }
    // gap: rem;
    h1 {
      text-align: start;
      font-size: clamp(30px, 8vw, 109px);
      background: radial-gradient(
        55.95% 97.37% at 46.69% 2.63%,
        // #ffb571 0,
        #477ff4 36.01%,
        // #07bda9 36.01%,
        // #c2cbfe
        #fff 82.09%
      );
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      color: transparent;
      @include respond-below(lg) {
        padding-left: 3.5rem;
        line-height: 1.3;
      }
      @include respond-below(sm) {
        margin-bottom: 0rem;
        padding-left: 0rem;
        line-height: 1.5;
        text-align: center;
        font-size: clamp(30px, 11vw, 60px);
      }
    }
    h2 {
      font-size: clamp(30px, 8vw, 109px);
      text-align: end;
      color: #d8d7d7e6;
      @include respond-below(lg) {
        padding-right: 3.5rem;
        line-height: 1.1;
      }
      @include respond-below(sm) {
        margin-bottom: 1.5rem;
        padding-right: 0rem;
        text-align: center;
        font-size: clamp(30px, 11vw, 60px);
      }
    }
  }
}
.content {
  display: flex;
  flex-direction: column;
  font-size: 3rem;
  p {
    // margin-top: 5rem;
    display: grid;
    place-content: center;
    background-image: radial-gradient(
      50% 220% at 50% 100%,
      #ed7dff 0,
      #6c54ff 25%,
      #fff 60%,
      #fff 100%
    );

    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;
    background-size: 200%;
    background-position-x: 100%;
    font-size: 2.6875rem;
    letter-spacing: -2.2055px;
    line-height: 1.4;
    margin-bottom: 8rem;
    @include respond-below(lg) {
      // margin-top: 4rem;
      font-size: 1.95rem;
      line-height: 2.4rem;
      margin-bottom: 6rem;
    }
    @include respond-below(sm) {
      font-size: 1.68rem;
      margin-bottom: 4rem;
      line-height: 1.2;
      letter-spacing: -1.2032px;
    }
  }
  p:last-child {
    margin-top: 1rem;
    background-size: 200%;
    background-position-x: 66.6667%;
  }
}
.creator {
  padding: 6rem 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: 3rem;
  gap: 3rem;
  @include respond-below(lg) {
    padding: 5rem 3rem;
  }
  @include respond-below(sm) {
    gap: 2rem;
    padding: 1rem;
  }
}
.second-image {
  width: 100%;
  display: flex;
  justify-content: center;
  position: relative;
  margin-bottom: 5rem;
  @include respond-below(sm) {
    height: calc(var(--vh, 1vh) * 80);
    min-height: 400px;
  }
  .image {
    width: 100%;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      @include respond-below(sm) {
        height: 100%;
        object-fit: cover;
      }
    }
    .overlay-top {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: calc(var(--vh, 1vh) * 25);
      z-index: 1;
      background: linear-gradient(
        180deg,
        #000 0,
        rgba(0, 0, 0, 0.738) 19%,
        rgba(0, 0, 0, 0.541) 34%,
        rgba(0, 0, 0, 0.382) 47%,
        rgba(0, 0, 0, 0.278) 56.5%,
        rgba(0, 0, 0, 0.194) 65%,
        rgba(0, 0, 0, 0.126) 73%,
        rgba(0, 0, 0, 0.075) 80.2%,
        rgba(0, 0, 0, 0.042) 86.1%,
        rgba(0, 0, 0, 0.021) 91%,
        rgba(0, 0, 0, 0.008) 95.2%,
        rgba(0, 0, 0, 0.002) 98.2%,
        transparent
      );
    }
    .overlay-bottom {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: calc(var(--vh, 1vh) * 70);
      z-index: 1;
      background: linear-gradient(
        0deg,
        #000 0,
        rgba(0, 0, 0, 0.738) 19%,
        rgba(0, 0, 0, 0.541) 34%,
        rgba(0, 0, 0, 0.382) 47%,
        rgba(0, 0, 0, 0.278) 56.5%,
        rgba(0, 0, 0, 0.194) 65%,
        rgba(0, 0, 0, 0.126) 73%,
        rgba(0, 0, 0, 0.075) 80.2%,
        rgba(0, 0, 0, 0.042) 86.1%,
        rgba(0, 0, 0, 0.021) 91%,
        rgba(0, 0, 0, 0.008) 95.2%,
        rgba(0, 0, 0, 0.002) 98.2%,
        transparent
      );

      @include respond-below(sm) {
        height: calc(var(--vh, 1vh) * 40);
        background: linear-gradient(
          0deg,
          #000 0,
          rgba(0, 0, 0, 0.738) 19%,
          rgba(0, 0, 0, 0.541) 34%,
          rgba(0, 0, 0, 0.382) 47%,
          rgba(0, 0, 0, 0.278) 56.5%,
          rgba(0, 0, 0, 0.194) 65%,
          rgba(0, 0, 0, 0.126) 73%,
          rgba(0, 0, 0, 0.075) 80.2%,
          rgba(0, 0, 0, 0.042) 86.1%,
          rgba(0, 0, 0, 0.021) 91%,
          rgba(0, 0, 0, 0.008) 95.2%,
          rgba(0, 0, 0, 0.002) 98.2%,
          transparent
        );
      }
    }
  }
  .image-text {
    width: 100%;
    max-width: 1200px;
    position: absolute;
    bottom: -12rem;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
    text-align: center;
    margin-bottom: 2rem;
    @include respond-below(lg) {
      bottom: -15%;
    }
    @include respond-below(sm) {
      bottom: -10%;
    }
    .main-title {
      width: 100%;
      padding: 0rem 2rem;
      text-align: left;
      font-size: clamp(30px, 8vw, 100px);
      margin-bottom: 1rem;
      letter-spacing: -1px;
      // color: #ffffff;
      background-image: linear-gradient(
        90deg,
        #fff 1.51%,
        #5d5be6 18.01%,
        #ffff 82.09%
      );
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      font-weight: 600;
      line-height: 1;
      // text-shadow: 0 2px 4px rgba(0, 0, 0, 0.8), 0 4px 8px rgba(0, 0, 0, 0.6),
      //   0 8px 16px rgba(0, 0, 0, 0.4);

      @include respond-below(lg) {
        padding-left: 3.5rem;
        line-height: 1.1;
      }
      @include respond-below(sm) {
        margin-bottom: 0rem;
        padding-left: 1rem;
        line-height: 1.1;
        text-align: left;
        font-size: clamp(30px, 11vw, 60px);
        background-image: unset;
        background-clip: unset;
        -webkit-background-clip: unset;
        -webkit-text-fill-color: unset;
        color: #ffff;
      }
    }
  }
}
</style>
